module.exports = __webpack_public_path__ + "img/pos-leaderboard-badge-rank-5.0b7072dd.svg";